/**
 * Pure Helfer für den Projekt-Wizard — ohne DOM/React testbar.
 */

export interface WizardCustomer {
  id: string;
  name: string;
  // API-Feldname (Prisma Customer.contactEmail) — NICHT `email` (war der Bug:
  // Frontend las c.email → immer leer, Suche traf nie auf die E-Mail).
  contactEmail?: string | null;
  // Kundenadresse — wird als Default in den Adress-Schritt übernommen (Selbstläufer).
  address?: string | null;
}

/**
 * Kundensuche für die Wizard-Auswahl: case-insensitive Teilstring-Treffer auf
 * Name oder E-Mail. Leere Suche = alle Kunden (Dropdown zeigt die volle Liste).
 */
export function filterCustomers(
  customers: WizardCustomer[],
  query: string,
): WizardCustomer[] {
  const q = query.trim().toLowerCase();
  if (!q) return customers;
  return customers.filter(
    (c) =>
      c.name.toLowerCase().includes(q) ||
      (c.contactEmail ?? "").toLowerCase().includes(q),
  );
}

/**
 * Gültigkeit der Kundenwahl: Es muss ein EXPLIZIT gewählter Kunde aus der
 * geladenen Liste sein — kein stilles Default auf den ersten Eintrag.
 */
export function isCustomerSelectionValid(
  customers: WizardCustomer[],
  selectedId: string,
): boolean {
  return selectedId !== "" && customers.some((c) => c.id === selectedId);
}
